import { ComputedRef, computed } from 'vue';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { userQueries } from '@services/identity-api/queries/User';
import { Claims } from './types';

export function useClaims(): ComputedRef<(Claims & { isInitialLoading: boolean; isSuccess: boolean }) | undefined> {
  const {
    data: claims,
    isInitialLoading,
    isSuccess
  } = useQuery({
    ...userQueries.getClaims,
    select: e => e.data,
    staleTime: 60 * 1000,
    retry: 10
  });
  return computed(() => ({
    isInitialLoading: isInitialLoading.value,
    isSuccess: isSuccess.value,
    isWebmodule: claims.value?.some(d => d.type === 'WebmoduleId' && d.value !== '0') ?? false,
    isTemporaryUser: claims.value?.some(d => d.type === 'IsTemporaryUser' && d.value === 'True') ?? false,
    isInternal: claims.value?.some(d => d.type === 'IsInternal' && d.value === 'True') ?? false,
    webmoduleId: claims.value?.some(d => d.type === 'WebmoduleId')
      ? Number(claims.value?.filter(d => d.type === 'WebmoduleId')[0].value)
      : undefined
  }));
}

export function useRefreshClaims(): { refresh: () => Promise<void> } {
  const queryClient = useQueryClient();
  return { refresh: () => queryClient.invalidateQueries(userQueries.getClaims) };
}
